import React, { useState } from "react";
import { ChunkCitation, OrgCategory } from "../../generated/core-api";
import { useDocumentDownload } from "../hooks/useDocumentDownload";
import { CitationChunkItem } from "./CitationChunkItem";
import styles from "./CitationView.module.css";

interface CitationDocItemProps {
  docId: string;
  citations: ChunkCitation[];
}

export const CitationDocItem: React.FC<CitationDocItemProps> = ({
  docId,
  citations,
}) => {
  const [showAllChunks, setShowAllChunks] = useState(false);
  const { isLoading, handleDocumentClick } = useDocumentDownload(
    citations[0].org_category as OrgCategory,
    citations[0].org_id,
    docId,
    citations[0].doc_name ?? docId
  );

  // Always show at least the first chunk, and show all if expanded or fewer than 4
  const visibleCitations =
    showAllChunks || citations.length <= 3 ? citations : citations.slice(0, 2);

  const hasMoreChunks = citations.length > 3 && !showAllChunks;

  return (
    <li className={styles.citationItem}>
      <div className={styles.citationContent}>
        <span className={styles.citationDoc}>
          Document:{" "}
          {isLoading ? (
            <span className={styles.loadingText}>Loading...</span>
          ) : (
            <a
              href="#"
              onClick={handleDocumentClick}
              className={styles.documentLink}
            >
              {citations[0].doc_name ?? docId}
            </a>
          )}
        </span>

        {citations.length > 0 && (
          <div className={styles.citationChunks}>
            <ul className={styles.citationChunksList}>
              {visibleCitations.map((citation) => (
                <CitationChunkItem
                  key={citation.chunk_id}
                  citation={citation}
                />
              ))}

              {hasMoreChunks && (
                <li className={styles.citationChunkItem}>
                  <button
                    className={styles.showMoreButton}
                    onClick={() => setShowAllChunks(true)}
                  >
                    + Show {citations.length - 2} more chunks
                  </button>
                </li>
              )}

              {showAllChunks && citations.length > 3 && (
                <li className={styles.citationChunkItem}>
                  <button
                    className={styles.showMoreButton}
                    onClick={() => setShowAllChunks(false)}
                  >
                    - Show fewer
                  </button>
                </li>
              )}
            </ul>
          </div>
        )}
      </div>
    </li>
  );
};
